import InboxMembersAPI from '../../api/inboxMembers';

export const actions = {
  get(_, { inboxId }) {
    return InboxMembersAPI.show(inboxId);
  },
  create(_, { inboxId, agentList, autoAssignDisabledIds }) {
    return InboxMembersAPI.update({
      inboxId,
      agentList,
      autoAssignDisabledIds,
    });
  },
};

export default {
  namespaced: true,
  actions,
};
